import 'moment/locale/pt-br'

import axios from 'axios'
import { Grid, Input } from 'bold-ui'
import { alert } from 'components/alert'
import { setDefaultOnSubmitFailed } from 'components/form'
import moment from 'moment'
import qs from 'qs'

export * from './history'

export default function initialSetup() {
  moment.updateLocale('pt-BR')

  axios.defaults.paramsSerializer = {
    serialize: (params) =>
      qs.stringify(params, { skipNulls: true, allowDots: true, encode: false, arrayFormat: 'repeat' }),
  }

  // O axios só anexa o header X-XSRF-TOKEN em requisições same-origin (heurística padrão), o que evita
  // vazar o token para terceiros. Se o backend passar a ficar em outra origin, configurar
  // axios.defaults.withXSRFToken com uma função que valide a origin do destino em vez de habilitar de forma global.

  Input.defaultProps.autoComplete = 'off'

  setDefaultOnSubmitFailed((state, suppressNotificationError) => {
    !suppressNotificationError &&
      state.hasValidationErrors &&
      alert('danger', 'Existem campos preenchidos de forma incorreta.')
  })

  Grid.defaultProps = {
    ...Grid.defaultProps,
    gap: {
      xs: 1,
      sm: 1,
      md: 1,
      lg: 2,
      xl: 2,
    },
  }
}
